
import { Component } from 'vue-property-decorator';

import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';

import MerchantConfigAddEdit from '@/views/DashView/MerchantConfig/MerchantConfigAddEdit.vue';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

class MerchantConfigItem {
  autoPrintStages: string = '';
  createdAt: string = '';
  deletedAt: any = null;
  edcMapping: string = '';
  id: number = 0;
  isAutoPrintReceipt: number = 0;
  outletCode: string = '';
  printingAddress: string = '';
  printingType: string = '';
  status: number = 0;
  updatedAt: string = '';
  messageGroup: string = '';
  staffPinValid: number = 0;
}

@Component({
  components: {
    editor: MerchantConfigAddEdit
  }
})
export default class MerchantConfigList extends RemoteDataTable<
  MerchantConfigItem
  > {
  public pageTitle: string = 'Merchant Config List';

  public newButtonText: string = 'New Merchant Config';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),
    new RemoteDataField({ key: 'outletCode', label: 'Outlet Code' }),
    new RemoteDataField({ key: 'isAutoPrintReceipt', label: 'Is Auto Print Receipt' }),
    new RemoteDataField({ key: 'printingType', label: 'Printing Type' }),
    new RemoteDataField({ key: 'status', label: 'Status' }),
    new RemoteDataField({ key: 'staffPinValid', label: 'Staff Pin Valid' }),
    new RemoteDataField({ key: 'autoPrintStages', label: 'Auto Print Stages' }),
    new RemoteDataField({ key: 'messageGroup', label: 'Message Group' }),
  ];

  // to get page data
  get items(): MerchantConfigItem[] {
    return this.$store.getters.GetAllMerchantConfig;
  }

  get paging(): MerchantConfigItem[] {
    return this.$store.getters.PagingMerchantConfig;
  }

  get sorting(): MerchantConfigItem[] {
    return this.$store.getters.SortingMerchantConfig;
  }

  get filtering(): MerchantConfigItem[] {
    return this.$store.getters.FilteringMerchantConfig;
  }
  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingMerchantConfig', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc
    });
  }
  mounted() {
    if (!this.$store.state.commonUtils.isFetchingData) {
      this.reload();
    }
  }
  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringMerchantConfig', {
      isResetFilter: isResetFilter
    });
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.merchantConfig.pagingMerchantConfig.page = 1;
    }
    this.$store.dispatch('GetAllMerchantConfig');
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteMerchantConfig', item.id)
          .then(response => {
            getResponseToMTH(response, this.$swal, constants.RECORD_IS_DELETED);
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  setPerPage(page) {
    this.$store.state.merchantConfig.pagingMerchantConfig.size = page;
    this.$store.dispatch('GetAllMerchantConfig');
  }
}
